<template>
  <StreamingLayout>
    <div class="login-wrapper">
      <div class="login-box shadow bg-white rounded-4 p-4">
        <h4 class="text-center mb-4 fw-bold text-primary">Acceso al evento en línea</h4>

        <form @submit.prevent="validarCredenciales">
          <!-- Email -->
          <div class="mb-3">
            <label class="form-label">Correo electrónico</label>
            <div class="input-group">
              <span class="input-group-text bg-white border-end-0">
                <i class="bi bi-envelope-fill text-muted"></i>
              </span>
              <input
                v-model="email"
                type="email"
                class="form-control border-start-0"
                placeholder="correo@ejemplo.com"
                autocomplete="email"
                required
              />
            </div>
          </div>

          <!-- Password -->
          <div class="mb-4">
            <label class="form-label">Contraseña</label>
            <div class="input-group">
              <span class="input-group-text bg-white border-end-0">
                <i class="bi bi-lock-fill text-muted"></i>
              </span>
              <input
                v-model="password"
                type="password"
                class="form-control border-start-0"
                placeholder="********"
                autocomplete="current-password"
                required
              />
            </div>
          </div>

          <!-- Error inline -->
          <div
            v-if="errorMsg"
            class="alert alert-danger py-2 mb-3"
            style="font-size: 0.9rem"
          >
            {{ errorMsg }}
          </div>

          <!-- Botón -->
          <div class="d-grid">
            <button class="btn btn-primary" type="submit" :disabled="cargando">
              <span v-if="cargando" class="spinner-border spinner-border-sm me-2"></span>
              {{ cargando ? "Verificando..." : "Entrar al evento" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </StreamingLayout>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import StreamingLayout from "@/components/Evento-Julio/Streaming/StreamingLayout.vue";
import { streamingLogin } from "@/utils/api_evento";

const email = ref("");
const password = ref("");
const cargando = ref(false);
const errorMsg = ref("");
const router = useRouter();

async function validarCredenciales() {
  errorMsg.value = "";
  cargando.value = true;

  try {
    const data = await streamingLogin({ email: email.value, password: password.value });

    // Guardar jti y expiración — el back usa sesión propia, no JWT
    localStorage.setItem("streaming_jti", data.jti);
    localStorage.setItem("streaming_expira_en", data.expira_en);
    localStorage.setItem("streaming_email", data.email);

    router.push("/evento-en-vivo");
  } catch (error) {
    const status = error.response?.status;
    if (status === 401) {
      errorMsg.value = "Correo o contraseña incorrectos.";
    } else if (status === 403) {
      errorMsg.value =
        error.response?.data?.detail || "Tu acceso ha expirado o está desactivado.";
    } else {
      errorMsg.value = "No fue posible conectarse. Intenta de nuevo.";
    }
  } finally {
    cargando.value = false;
  }
}
</script>

<style scoped>
.login-wrapper {
  min-height: 100vh;
  background-image: url("@/assets/img/Evolve/img_2.jpg");
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 1rem;
}

.login-box {
  width: 100%;
  max-width: 420px;
}

.input-group-text {
  width: 42px;
  justify-content: center;
}

input::placeholder {
  font-style: italic;
}
</style>
